var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    rx: 3,
    fill: "#888FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3267 48.3288V41.6575L70 38.989V50.9973L59.3267 48.3288ZM49.9876 19C53.6689 19 56.6584 21.9897 56.6584 25.6712C56.6584 29.3528 53.6689 32.3425 49.9876 32.3425C46.3064 32.3425 43.3416 29.3528 43.3416 25.6712C43.3416 21.9897 46.3064 19 49.9876 19ZM36.6708 24.337C38.8697 24.337 40.6733 26.116 40.6733 28.3397C40.6733 30.5388 38.8697 32.3425 36.6708 32.3425C34.4472 32.3425 32.6683 30.5388 32.6683 28.3397C32.6683 26.116 34.4472 24.337 36.6708 24.337ZM34.0025 35.011H52.656C54.8548 35.011 56.6584 36.79 56.6584 38.989V50.9973C56.6584 53.1963 54.8548 55 52.656 55H34.0025C31.8036 55 30 53.1963 30 50.9973V38.989C30 36.79 31.8036 35.011 34.0025 35.011Z",
    fill: "#CDD1DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPreview);
export default __webpack_public_path__ + "static/media/video-preview.26721b083dbeb6e5119c09e19dd5da65.svg";
export { ForwardRef as ReactComponent };